import { Navigate } from "react-router-dom"
import { Feature } from "lib/@components/feature"
import { FEATURE_FLAG_PROJECT_BRIDGE } from "./server/feature-flag-project-bridge.mjs"
import { ProjectBridgeListContent } from "./project-bridge-list-content"

export function ProjectBridgeListPage() {
    return (
        <Feature feature={FEATURE_FLAG_PROJECT_BRIDGE} fallback={<Navigate to="/app" replace />}>
            <ProjectBridgeListContent />
        </Feature>
    )
}
